<div
  class="dynamic-field form-input"
  [ngClass]="[
    config.name + '-container',
    isRequired ? 'dynamic-field--required' : '',
    config.message ? 'margin__bottom__16' : ''
  ]"
  [formGroup]="group"
>
  <cwc-input-number
    [label]="config.label | translate"
    [formControlName]="config.name"
    [min]="minVal"
    [rtl]="rtl"
    [step]="step"
    [max]="maxVal"
    [status]="formControlStatus$ | async"
    [unit]="config.suffix ? config.suffix : ''"
    [decimalPlaces]="decimals"
    [attr.data-tid]="config?.dataTId"
    [attr.data-test]="config?.dataTId"
    [attr.data-name]="config?.name"
    [required]="isRequired"
    [hideButtons]="config.hideControls ? config.hideControls : false"
    [decimalSeparator]="decimalSeparator"
    [thousandSeparator]="thousandSeparator"
    (cwcChange)="checkForNull($event.detail)"
    (cwcInputChange)="onInputChange($event.detail)"
    [attr.status]="fieldControl.invalid && !fieldControl.untouched ? 'error' : null"
    [attr.status-message]="
      (controlStatusMessage$ | async)
        ? (controlStatusMessage$ | async | translate: (statusMessageParameter$ | async))
        : fieldControl.invalid && !fieldControl.untouched
          ? fieldControl.hasError('errorMessage') || errorMessage
            ? (fieldControl.errors['errorMessage'] | translate: (statusMessageParameter$ | async))
            : errorMessage
              ? errorMessage
              : null
          : null
    "
    designVersion="v2"
  >
  </cwc-input-number>
  <div *ngIf="message && !(fieldControl.invalid && fieldControl.hasError('errorMessage'))" class="message">
    {{ message }}
  </div>
</div>
